export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }
  var p={
    businessId:$params.businessId,
    batchId:$params.batchId,
    draftsDocId:$params.draftsDocId,
    taskId:$params.taskId,
    appId:$params.appId,
    formId:$params.formId,
    isOperation : false
  }
  if($params.extParams && $params.extParams.fullAuthType){
    p.fullAuthType = $params.extParams.fullAuthType;
  }
  PF.show("flowWorktrack", p, function(res){
  },function(isOperation,hasDoging){
    if(!isOperation){
      let yzStatus = hasDoging ? "在办" :"办毕";
      PF.invoke("#/api/process/updateYzStatus",$params.taskId,yzStatus);
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-worktrack.js